export const softType = [
  {
    name: '0',
    text: '应用平台',
    selectType: 'softType',
  },
  {
    name: '1',
    text: 'PC应用',
    selectType: 'softType',
  },
  {
    name: '2',
    text: '安卓应用',
    selectType: 'softType',
  },
];

export const softCategory = [
  {
    name: '0',
    text: '应用分类',
    selectType: 'softCategory',
  },
  {
    name: '1',
    text: '游戏',
    selectType: 'softCategory',
  },
  {
    name: '2',
    text: '软件',
    selectType: 'softCategory',
  },
];
export const wallpaperDpi = [
  {
    name: '0',
    text: '分辨率',
    selectType: 'wallpaperDpi',
  },
  {
    name: '1',
    text: '1080P',
    selectType: 'wallpaperDpi',
  },
  {
    name: '2',
    text: '2K',
    selectType: 'wallpaperDpi',
  },
  {
    name: '3',
    text: '4K',
    selectType: 'wallpaperDpi',
  },
];
export const wallpaperPay = [
  {
    name: '0',
    text: '版权',
    selectType: 'wallpaperPay',
  },
  {
    name: '1',
    text: '免费',
    selectType: 'wallpaperPay',
  },
  {
    name: '2',
    text: '付费',
    selectType: 'wallpaperPay',
  },
];

export const postType = [
  {
    name: '0',
    text: '类型',
    selectType: 'postType',
  },
  {
    name: '1',
    text: '社区帖子',
    selectType: 'postType',
  },
  {
    name: '2',
    text: '专题小编',
    selectType: 'postType',
  },
];

export const coursePay = [
  {
    name: '0',
    text: '版权',
    selectType: 'coursePay',
  },
  {
    name: '1',
    text: '免费',
    selectType: 'coursePay',
  },
  {
    name: '2',
    text: '付费',
    selectType: 'coursePay',
  },
];
